import { Pin, X, ChevronRight, PinOff } from "lucide-react";
import shopApi from "../../../../api/shopApi";
import { useNotification } from "../../../../hooks/useNotification";

const MAX_PINNED_MESSAGES = 10;

export function PinnedMessagesPanel({
  shop,
  contact,
  pinnedMessages,
  onClose,
  onNavigateToMessage,
  onUnpin,
  staffName,
}) {
  const { addNotification } = useNotification();

  const handleUnpin = async (e, pinnedItem) => {
    e.stopPropagation();

    try {
      const result = await shopApi.unpinMessage({
        shopId: shop._id,
        conversationUid: contact.uid,
        messageId: pinnedItem.messageId,
        unpinnedByName: staffName || "Người dùng",
      });

      if (result.status === 1) {
        addNotification("Đã bỏ ghim tin nhắn", 1);
        onUnpin?.(pinnedItem.messageId);
      } else {
        addNotification(result.message, result.status);
      }
    } catch (error) {
      addNotification("Có lỗi xảy ra", -1);
    }
  };

  const getMessagePreview = (message) => {
    if (!message) return "[Tin nhắn không tồn tại]";
    if (message.isUndo) return "[Tin nhắn đã thu hồi]";
    if (message.content) return message.content;
    if (message.img) return "[Hình ảnh]";
    if (message.file) return "[Tập tin]";
    return "[Tin nhắn]";
  };

  if (!pinnedMessages || pinnedMessages.length === 0) {
    return null;
  }

  return (
    <div className="bg-blue-50 border-b border-blue-200 p-3">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2">
          <Pin className="w-4 h-4 text-blue-600" />
          <span className="font-medium text-sm text-blue-800">
            Tin nhắn đã ghim ({pinnedMessages.length}/{MAX_PINNED_MESSAGES})
          </span>
        </div>
        <button
          onClick={onClose}
          className="p-1 hover:bg-blue-100 rounded transition-colors"
        >
          <X className="w-4 h-4 text-blue-600" />
        </button>
      </div>

      <div className="max-h-40 overflow-y-auto space-y-2">
        {pinnedMessages.map((pinned) => (
          <div
            key={pinned.id || pinned._id}
            className="flex items-center justify-between p-2 bg-white rounded hover:bg-blue-100 cursor-pointer transition-colors group"
            onClick={() => onNavigateToMessage(pinned.messages)}
          >
            <div className="flex-1 min-w-0 mr-2">
              <p className="text-sm text-gray-800 truncate">
                {getMessagePreview(pinned.messages)}
              </p>
            </div>

            <div className="flex items-center gap-1">
              <button
                onClick={(e) => handleUnpin(e, pinned)}
                className="p-1 hover:bg-red-100 rounded opacity-0 group-hover:opacity-100 transition-opacity"
                title="Bỏ ghim"
              >
                <PinOff className="w-4 h-4 text-red-500" />
              </button>
              <ChevronRight className="w-4 h-4 text-gray-400" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
